import axios from 'axios'
import { BASE_URL } from '../requests/urls'

const client = axios.create({
    baseURL: BASE_URL, headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
    }
})
// client.interceptors.response.use(res => res.data)

client.interceptors.response.use(res => res.data, function (error) {
    console.log(error);
    if (error?.response?.status === 401) {
        localStorage.removeItem('token');
        window.location = '/signin';
    } if (error)
        throw Error()
}
)

export default client